// extracted by mini-css-extract-plugin
module.exports = {"root":"_1w0tU","tb_pinLayerDockedBottom-root":"_342kG","tbPinLayerDockedBottomRoot":"_342kG"};